import React, { useEffect } from 'react';
import { useRef, useState } from "react";
import "./DragDrop.scss";
import axios from 'axios';
import { BaseUrl } from "../../../config"

const DragDrop = ({
  preferencias,
  setPrefenrencias,
  files,
  setFiles,
  filesDB,
  setLoading,
  setOpenModal
 }) => {
  const [dragActive, setDragActive] = useState(false);
  const inputRef = useRef(null);

  const [keepPopupPreview, setKeepPopupPreview] = useState(-1);

  //CLICK BTN
  const handleChange = (e) => {
    setLoading(true)
    e.preventDefault();

    if (e.target.files && e.target.files[0]) {
      for (let i = 0; i < e.target.files["length"]; i++) {
        setFiles((prevState) => [...prevState, e.target.files[i]]);
      }
    }
    setLoading(false)
  }


  //CLICK ARRASTAR
  const handleDrop = (e) => {
    if(preferencias){
      setPrefenrencias(false)
      setOpenModal(true)
    }
    setLoading(true)
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      for (let i = 0; i < e.dataTransfer.files["length"]; i++) {
        setFiles((prevState) => [...prevState, e.dataTransfer.files[i]]);
      }
    }
    setLoading(false)
  }


  const handleDragLeave = (e) => {
    if(preferencias){
      setPrefenrencias(false)
      setOpenModal(true)
    }
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  }

  const handleDragOver = (e) => {
    if(preferencias){
      setPrefenrencias(false)
      setOpenModal(true)
    }
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  }

  const handleDragEnter = (e) => {
    if(preferencias){
      setPrefenrencias(false)
      setOpenModal(true)
    }
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  }



  const openFileExplorer = () => {
    if(preferencias){
      setPrefenrencias(false)
      setOpenModal(true)
        inputRef.current.value = "";
        inputRef.current.click();
   
 
    }else {
      inputRef.current.value = "";
      inputRef.current.click();
    }
 
  }

  return (
    <div className="drag-drop-component">
      <article
        className={`drag-drop ${dragActive ? "drag-drop-active" : ""}`}
        onDragEnter={handleDragEnter}
        onDrop={handleDrop}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
      >

        <input
          placeholder="fileInput"
          className="hidden"
          ref={inputRef}
          type="file"
          multiple={false}
          onChange={handleChange}
          accept="xlsx"
        />

        <svg xmlns="http://www.w3.org/2000/svg" width="53" height="48" fill="none" viewBox="0 0 53 48">
          <path stroke="#334443" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3" d="M37.827 41.436a13.087 13.087 0 0 0 8.9-3.417c8.038-7.03 3.736-21.141-6.86-22.469C36.083-7.41 2.969 1.292 10.81 23.146" />
          <path stroke="#334443" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="3" d="M14.892 24.154a8.958 8.958 0 0 0-4.204-.983c-11.456.811-11.431 17.479 0 18.29m25.199-24.878a9.437 9.437 0 0 1 4.08-1.008M28.88 41.437h-9.833m4.918 4.916V36.52" />
        </svg>


        <p> {preferencias ? "" : "Arrastrá y soltá o"} <b style={{
          color: "#003049",
          textDecoration: "underline",
          cursor: "pointer"
        }}
          onClick={openFileExplorer}
        >Buscá</b> tus archivos</p>

        <p style={{
          fontSize:"14px"
        }}>Formatos admitidos: .xls y .xlsx</p>


      </article>
      {/* {
        files.length ?
          <>


            {files.map((file, idx) => (
              <div key={idx} className="file-preview">
                <p>{file.name} - <b>Borrar</b> </p>

              </div>
            ))}



          </>
          : null
      } */}
    </div>
  );
};

export default DragDrop;